
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theatres/[slug]",
      function () {
        return require("private-next-pages/theatres/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/theatres/[slug]"])
      });
    }
  